import React from "react";

export default function HorizontalCardLoader({ dark = false }) {
  const bgClass = dark ? "bg-zinc-900/60 border-zinc-800/80 shadow-zinc-950/40" : "bg-white border-gray-100 shadow-gray-200/50";
  const placeholderClass = dark ? "bg-zinc-800/60" : "bg-gray-200";

  return (
    <>
      <div className="w-full flex items-center flex-col py-2">
        <div className={`flex flex-col w-full max-w-[11rem] lg:max-w-[13rem] xl:max-w-[14rem] shadow-md rounded-xl border items-center overflow-hidden ${bgClass}`}>
          {/* Card Image Skeleton */}
          <div
            data-placeholder=""
            className={`h-[10rem] lg:h-[13rem] xl:h-[14rem] w-full overflow-hidden relative ${placeholderClass}`}
          />
          {/* Content Rows */}
          <div className="flex flex-col p-3 w-full gap-2">
            <div className="flex items-center gap-1.5 w-full">
              <div
                data-placeholder=""
                className={`h-4 w-4 rounded-full overflow-hidden relative ${placeholderClass}`}
              />
              <div
                data-placeholder=""
                className={`h-4 w-3/4 rounded overflow-hidden relative ${placeholderClass}`}
              />
            </div>
            <div className="flex items-center gap-1.5 w-full">
              <div
                data-placeholder=""
                className={`h-3 w-full rounded overflow-hidden relative ${placeholderClass}`}
              />
            </div>

            {/* Bottom Actions Skeleton Row */}
            <div className="flex justify-between items-center mt-3 pt-3 border-t border-zinc-800/40 w-full gap-2">
              <div
                data-placeholder=""
                className={`h-4 w-1/3 rounded overflow-hidden relative ${placeholderClass}`}
              />
              <div
                data-placeholder=""
                className={`h-4 w-1/3 rounded overflow-hidden relative ${placeholderClass}`}
              />
            </div>
          </div>
        </div>
      </div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
            [data-placeholder]::after {
              content: " ";
              box-shadow: 0 0 50px 12px ${dark ? "rgba(255,255,255,0.06)" : "rgba(255,255,255,0.8)"};
              position: absolute;
              top: 0;
              left: -100%;
              height: 100%;
              width: 50%;
              animation: load 1.2s infinite;
            }
            @keyframes load {
              0% { left: -100% }
              100% { left: 150% }
            }
          `,
        }}
      />
    </>
  );
}

